import React, { PropTypes } from 'react';
import Copy from '../copy';

const LineItem = ({ lineItem, onRemoveItem }) => {
  const badges = lineItem.cardTypes.map((cardType) => (
    <li style={{ marginRight: '4px' }} key={cardType}>
      <span className={`badge ${cardType}`}>
        {cardType}
      </span>
    </li>
  ));

  return (
    <li className="line-item">
      <a className="img-link" href={lineItem.cardUrl}>
        <span className="img">
          <img alt={lineItem.image.alt} src={lineItem.image.url} />
        </span>
      </a>
      <div className="info">
        <a className="name" href={lineItem.cardUrl}>
          {lineItem.name}
        </a>
        <ul className="badges unstyled">
          {badges}
        </ul>
        <span className="price">
          {Copy.lineItemPrice(lineItem.costPrice, lineItem.price)}
        </span>
      </div>
      <a className="icon-remove remove"
        rel="nofollow"
        onClick={() => onRemoveItem()}
      ></a>
    </li>
  );
};

LineItem.propTypes = {
  lineItem: PropTypes.object.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
};

export default LineItem;



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/components/LineItem.js
 **/